var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { SyfLoader } from 'syf-component-library/ui/atoms/Loader';
import { SyfLoaderWrapper } from './subcomponents';
var AlertsLazyLoader = function () {
    return (_jsx(SyfLoaderWrapper, __assign({ "data-test": "SyfLoaderWrapper" }, { children: _jsx(SyfLoader, { size: 5 }) })));
};
export default AlertsLazyLoader;
